var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckmark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.159 22.0092L25.5457 32.0092C25.2323 32.4208 24.7473 32.6642 24.2307 32.6675H24.219C23.7073 32.6675 23.224 32.4308 22.9073 32.0275L18.854 26.8492C18.2873 26.1258 18.414 25.0775 19.139 24.5108C19.8623 23.9425 20.9123 24.0692 21.479 24.7958L24.2007 28.2725L30.5073 19.9908C31.064 19.2592 32.109 19.1158 32.844 19.6742C33.5757 20.2325 33.7173 21.2775 33.159 22.0092ZM26.0007 9.33417C16.7957 9.33417 9.334 16.7958 9.334 26.0008C9.334 35.2042 16.7957 42.6675 26.0007 42.6675C35.2057 42.6675 42.6673 35.2042 42.6673 26.0008C42.6673 16.7958 35.2057 9.33417 26.0007 9.33417Z",
    fill: "#0080DB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkmark.8caf89b7.svg";
export { ForwardRef as ReactComponent };